import { SelectTrigger } from '@radix-ui/react-select';

import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectValue } from '@/components/ui/select';

type Props = {
  onPageSizeChange: (count: number) => void;
  onPaginationChange: (value: 'next' | 'prev') => void;
  pageSize: number;
  hasPrev: boolean;
  hasNext: boolean;
};

const pageSizeOptions = [10, 25, 50];

export const Pagination = ({
  onPaginationChange,
  onPageSizeChange,
  pageSize,
  hasPrev,
  hasNext,
}: Props) => {
  return (
    <>
      <Select
        value={`${pageSize}`}
        onValueChange={(value) => onPageSizeChange(Number.parseInt(value, 10))}
      >
        <SelectTrigger className="h-8 w-[70px] border hover:bg-slate-800">
          <SelectValue placeholder={pageSize} />
        </SelectTrigger>
        <SelectContent side="left">
          {pageSizeOptions.map((pageSize) => (
            <SelectItem key={pageSize} value={`${pageSize}`}>
              {pageSize}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPaginationChange('prev')}
        disabled={!hasPrev}
      >
        Previous
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onPaginationChange('next')}
        disabled={!hasNext}
      >
        Next
      </Button>
    </>
  );
};
